import videojs from 'video.js';

// Get the Component base class from Video.js
var ControlBar = videojs.getComponent('ControlBar');

// The videojs.extend function is used to assist with inheritance. In
// an ES6 environment, `class TitleBar extends Component` would work
// identically.
var DNSBar = videojs.extend(ControlBar, {

  // The constructor of a component receives two arguments: the
  // player it will be associated with and an object of options.
  constructor: function(player, options) {

    // It is important to invoke the superclass before anything else, 
    // to get all the features of components out of the box!
    ControlBar.call(this, player, options);

    this.addClass('vjs-d-ns-bar');

    this.player().ready(() => {});
  },

});

DNSBar.prototype.controlText_ = 'Herramientas D-NS';

// Register the component with Video.js, so it can be used in players.
videojs.registerComponent('DNSBar', DNSBar);

export default DNSBar;
